"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var Icon_1 = __importDefault(require("../Icon"));
var spin = (0, react_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from { transform: rotate(0deg) } \n  to { transform: rotate(360deg) }\n"], ["\n  from { transform: rotate(0deg) } \n  to { transform: rotate(360deg) }\n"])));
var getCSSRules = function () { return ({
    spinner: {
        animation: "".concat(spin, " 1s linear infinite"),
        display: 'inline-block',
    },
}); };
var Spinner = function (props) {
    var styles = getCSSRules();
    var className = props.className, rest = __rest(props, ["className"]);
    return ((0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
            var css = _a.css, cx = _a.cx;
            return ((0, jsx_runtime_1.jsx)(Icon_1.default, __assign({ name: 'loading', className: cx(className, css(styles.spinner)) }, rest), void 0));
        } }, void 0));
};
exports.default = Spinner;
var templateObject_1;
//# sourceMappingURL=index.js.map